<div class="avatar-container">
    @if (file) {
        <div
            class="image-container"
            [ngClass]="{ 'box-shadow-avatar': !!file }"
            [ngStyle]="{ backgroundImage: 'url(' + file + ')' }"></div>
    } @else {
        <div class="image-container avatar-placeholder"></div>
    }
</div>
